import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useAvatarGroupContext } from './avatar-group/avatar-group.context.js';
import { useAvatarContent } from './avatar.hooks.js';
import { resolveAvatarSize } from './avatar.utils.js';
import { colorClass } from './avatar-classes.js';
import { initial as initial$1, avatar } from './avatar.css.js';
import { initial, avatarReset } from './avatar-reset.css.js';
import { shape } from '../styles/avatar-base.css.js';

/**
 * Displays a user, workspace, or team identity as a photo, initial, icon, or unknown-state placeholder.
 *
 * Avatar is non-interactive. For an interactive avatar that acts as a button, use `AvatarButton`.
 *
 * Fallback order: `src` → `icon` → derived initial → `fallbackIcon`.
 *
 * @see https://fpl.figma.design/components/avatar/
 */
const Avatar = forwardRef(({ size = 'md', shape: shape$1 = 'circle', color, src, name, icon, fallbackIcon, dimmed, ...props }, ref) => {
    const group = useAvatarGroupContext();
    const effectiveSize = group?.size ?? size;
    const effectiveShape = group?.shape ?? shape$1;
    const { sizeClassName, sizeStyle, typographySize } = resolveAvatarSize(effectiveSize);
    const { type, content } = useAvatarContent({
        src,
        name,
        icon,
        fallbackIcon,
        initialClassName: clsx(initial, initial$1[typographySize]),
    });
    return (jsx("div", { "data-fpl-component": "", ...props, ref: ref, role: "img", style: sizeStyle, "data-dimmed": dimmed || undefined, "data-avatar-content": type, className: clsx(avatarReset, avatar, sizeClassName, shape[effectiveShape], colorClass(type, color)), children: content }));
});
Avatar.displayName = 'Avatar';

export { Avatar };
//# sourceMappingURL=avatar.js.map
